import React from 'react'
import { useInViewOnce } from '../../Utilities/Observer';

const Event = () => {
  const [ref, visible] = useInViewOnce();

  return (
    <section id='evento' className='w-screen bg-brand-black px-6 md:px-8 xl:px-[8vw] py-12 sm:py-16'>
      <div ref={ref} className={`transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        <article className='py-6'>
            <p className='font-mono text-brand-blue uppercase'>// The Event</p>
            <h2 className='uppercase text-brand-white font-display font-black text-4xl sm:text-[clamp(2.4rem,7vw,7.5rem)] leading-none'>
              AI walks into the classroom. <br/>
              What will <br/>
              you build?
            </h2>
        </article>
        <article className='py-8 sm:pt-12 sm:pb-20'>
          <p className='lg:w-1/2 text-white font-display text-lg sm:text-xl leading-relaxed'>
            Student Tech Clash is the <b className='text-brand-blue'>Reply</b> hackathon for students. 
            In this edition, <b className='text-brand-blue'>AI on Campus</b>, you will work on how <b className='text-brand-blue'>artificial intelligence </b>  
            can change education, training and learning.
          </p>
        </article>
        
        <article className='border-t border-brand-white/30 flex flex-col gap-6 sm:grid grid-cols-3 py-6'>
            <div className='text-brand-white'>
              <h2 className='text-[clamp(3rem,8vw,7.5rem)] font-black font-display'>2-4</h2>
              <p className='font-mono lowercase'>Members per team</p>
            </div>
            <div className='text-brand-white'>
              <h2 className='text-[clamp(3rem,8vw,7.5rem)] font-black font-display'>1</h2>
              <p className='font-mono lowercase'>Case Study</p>
            </div>
            <div className='text-brand-white'>
              <h2 className='text-[clamp(3rem,8vw,7.5rem)] font-black font-display'>FREE</h2>
              <p className='font-mono lowercase'>Free Participation</p>
            </div>
        </article>
        </div>
    </section>
  )
}

export default Event